<template>
    <section class="case-row row hidden-md hidden-lg">
        <img :src="casePhoto" class="img-responsive">
    </section>
</template>

<script>
export default {
    name: "CaseSection",
    props: {
        casePhoto: {
            type: String,
            required: true
        }
    },
}
</script>

<style lang="scss">
.pc-rental {
    .case-row {
        text-align: right;
        background-color: #a5a5a5;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding-left: 25px;

        .col-xs-12 {
            padding: 0;
        }
    }
}
</style>
